import { createSlice } from "@reduxjs/toolkit";
import { CreateProductProps } from "../types";

const initialState: CreateProductProps = {
  productId: null,
  createProductDtl: null,
};

const createProductDtl = createSlice({
  name: "product",
  initialState: initialState,
  reducers: {
    setCeateProductDtl(state, action) {
      state.createProductDtl = action.payload; // Correctly mutating the state
    },
    setProductId(state, action) {
      return {
        ...state,
        productId: action.payload, // Set the productId in the state
      };
    },
  },
});

export default createProductDtl.reducer;

export const { setCeateProductDtl, setProductId } = createProductDtl.actions;
